export default "__VITE_PUBLIC_ASSET__1c31e09f__"